export default "__VITE_ASSET__BEDBPGcC__"